import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
    BaseNestedFieldDefinition,
    ComplexMapFieldValue,
    DialogConfig,
    DialogStyle,
    ShDynamicDialogService
} from '@stylehaven/components';
import { ComplexValueDialogComponent } from '../../../dialog/complex-value-dialog/complex-value-dialog.component';

@Component({
    selector: 'med-complex-value-tag',
    templateUrl: './complex-value-tag.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComplexValueTagComponent {
    @Input() complexValue: ComplexMapFieldValue;

    @Input() complexFieldDefinition: BaseNestedFieldDefinition;

    // Required for now. Possible expansion to default use 'Label' or 'Name' subfield value as label
    @Input() label: string;

    constructor(private dialogService: ShDynamicDialogService) {}

    public showComplexValue(): void {
        const dialogConfig: DialogConfig = {
            title: this.label,
            options: {
                style: DialogStyle.Wide
            },
            data: {
                complexValue: this.complexValue,
                complexFieldDefinition: this.complexFieldDefinition
            }
        };

        this.dialogService.open(ComplexValueDialogComponent, dialogConfig);
    }
}
